"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.knowledge.base': '知识库',
    'onboarding.knowledge.title': '知识库（可选）',
    'onboarding.knowledge.description': '添加知识条目以增强您头像的专业知识和回答。',
    'onboarding.knowledge.final.step': '最后步骤 - 知识上传',
    'onboarding.knowledge.label': '选择知识条目',
    'onboarding.knowledge.placeholder': '为您的头像搜索和选择知识条目...',
    'onboarding.knowledge.skip.info': '如果需要，您可以跳过此步骤并稍后添加知识条目。',
    'onboarding.knowledge.selected.single': '个知识条目已选择',
    'onboarding.knowledge.selected.multiple': '个知识条目已选择',
    'onboarding.knowledge.bonus': '已添加知识',
    'onboarding.knowledge.items': '知识项目',
};
